import { Helmet } from "react-helmet"

interface CommonPixelProps {
    pixelId?: string|null;
}

export enum Tracker {
    SIGNUP = `signup`,
    DISCOVER = `discover`
}

const CommonPixel = (props: CommonPixelProps) => {
    const { pixelId } = props
    if (pixelId === Tracker.SIGNUP) {
        return (
            <Helmet>
                <script>
                    {
                        `
                        !function(s,a,e,v,n,t,z){if(s.saq)
                        return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);
                        t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];
                        z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');
                        saq('conv','1rURl9PWhvqk9LqKxwKRsF');saq('rt', 'tbW173716PUSLLFvpAqiRS');saq('lal', 'HtbawSmk3fbj8h9JEj1iG3');
                        `
                    }
                </script>
                <noscript>
                    {`<img src="https://tags.srv.stackadapt.com/conv?cid=1rURl9PWhvqk9LqKxwKRsF" width="1" height="1"/>
                    <img src="https://tags.srv.stackadapt.com/rt?cid=tbW173716PUSLLFvpAqiRS" width="1" height="1"/>
                    <img src="https://tags.srv.stackadapt.com/lal?cid=HtbawSmk3fbj8h9JEj1iG3" width="1" height="1"/>`}
                </noscript>
            </Helmet>
        )
    }
    else if (pixelId === Tracker.DISCOVER) {
        return (
            <Helmet>
                <script>
                    {
                        `
                        !function(s,a,e,v,n,t,z)
                        {if(s.saq)return;n=s.saq=function()
                        {n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];
                        t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];
                        z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');
                        saq('conv','1Qlutb2eGOgjv77zo0reeK');saq('rt', 'Kj2toBLOi9tFA3j8meJL0f');saq('lal', 'sFXu7ZzeDG5nC4Tzz1KIED');
                        `
                    }
                </script>
                <noscript>
                    {`<img src="https://tags.srv.stackadapt.com/conv?cid=1Qlutb2eGOgjv77zo0reeK" width="1" height="1"/>
                    <img src="https://tags.srv.stackadapt.com/rt?cid=Kj2toBLOi9tFA3j8meJL0f" width="1" height="1"/>
                    <img src="https://tags.srv.stackadapt.com/lal?cid=sFXu7ZzeDG5nC4Tzz1KIED" width="1" height="1"/>`}
                </noscript>
            </Helmet>
        )
    }
    return (
        <>
        </>
    )
}

export default CommonPixel